import { useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_COST_PRICING } from "@/seoContentV3";

export default function usePricing() {
  const [pricing, setPricing] = useState(DEFAULT_COST_PRICING);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/pricing`)
      .then(({ data }) => { if (data?.tiers?.length) setPricing({ ...DEFAULT_COST_PRICING, ...data }); })
      .catch(() => {});
  }, []);
  return pricing;
}
